/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Vekn_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't copy the VEKN ID" |
*
* @param {User_List_Vekn_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_vekn_copy_failed = /** @type {((inputs?: User_List_Vekn_Copy_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Vekn_Copy_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de copier l'ID VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo copiar el ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível copiar o ID VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile copiare l'ID VEKN")
	return /** @type {LocalizedString} */ ("Couldn't copy the VEKN ID")
});